import { useState, useEffect } from 'react';

export default function useDebounce(value, delay) {
  const [debouncedValue, setDebouncedValue] = useState(value);
  let timeoutCancel = 0;

  useEffect(
    () => {
      timeoutCancel = setTimeout(() => {
        setDebouncedValue(value);
      }, delay);

      return () => {
        clearTimeout(timeoutCancel);
      };
    },
    [value, delay] // Only re-call effect if value or delay changes
  );

  return [debouncedValue, () => {
    clearTimeout(timeoutCancel);
  }];
}
